/**
 * Breakpoint constants for consistent use across CSS and JavaScript
 * Desktop starts at 1024 (--bp-desktop-min in ui/tokens/foundations.css).
 */
export const BREAKPOINTS = {
  mobile: 767,
  // T-012 — the last compact px: desktop (CSS, DS) starts at 1024, so 1024 must not be «tablet» in JS
  tablet: 1023,
  smallDesktop: 1440,
  desktop: 1920,
} as const;

/**
 * Media query strings for use in JavaScript
 */
export const MEDIA_QUERIES = {
  mobile: `(max-width: ${BREAKPOINTS.mobile}px)`,
  tablet: `(min-width: ${BREAKPOINTS.mobile + 1}px) and (max-width: ${BREAKPOINTS.tablet}px)`,
  smallDesktop: `(min-width: ${BREAKPOINTS.tablet + 1}px) and (max-width: ${BREAKPOINTS.smallDesktop - 1}px)`,
  desktop: `(min-width: ${BREAKPOINTS.smallDesktop}px)`,
  largeDesktop: `(min-width: ${BREAKPOINTS.desktop}px)`,
} as const;

